import React from 'react'
import { Box, Card, CardContent, Grid, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { fieldDateFormat } from '../../../../constants';

const LoanInputParameters = ({ inputData, handleInputChange, loanType, onLoanTypeChange, type,onRestErrorKey, error }) => {
     const gridSize = type === 'edit' ? { md: 4, xs: 12 } : { md: 3, xs: 12 };
    return (
        <>
            <Grid size={gridSize}>
                <TextField
                    required={type === 'edit'}
                    fullWidth
                    label="Borrower"
                    disabled={type === 'view'}
                    value={inputData?.borrower ? inputData?.borrower : null}
                    onChange={(e) => handleInputChange('borrower', e.target.value)}
                    variant="outlined"
                    size="small"
                    onFocus={() => onRestErrorKey('borrower')}
                    error={Boolean(error?.borrower)}
                    helperText={error?.borrower}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid>
            {loanType === 'variable-rate' ? <Grid size={gridSize}>
                <TextField
                    id="rent"
                    label="Rent ($)"
                    variant="outlined"
                    size="small"
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    margin="normal"
                    value={inputData?.rent ? inputData?.rent : null}
                    onChange={(e) => handleInputChange('rent', e.target.value)}
                    onFocus={() => onRestErrorKey('rent')}
                    error={Boolean(error?.rent)}
                    helperText={error?.rent}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                    fullWidth
                />
            </Grid> : null}
            {loanType === 'variable-rent' ? <Grid size={gridSize}>
                <TextField
                    id="rent"
                    label="Base Rent ($)"
                    variant="outlined"
                    size="small"
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    margin="normal" 
                    value={inputData?.rent ? inputData?.rent : null}
                    onChange={(e) => handleInputChange('rent', e.target.value)}
                    onFocus={() => onRestErrorKey('rent')}
                    error={Boolean(error?.rent)}
                    helperText={error?.rent}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                    fullWidth
                />
            </Grid> : null}
            <Grid size={gridSize}>
                <TextField
                    id="fixedRate"
                    label="Interest Rate (%)"
                    variant="outlined"
                    size="small"
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    margin="normal"         
                    value={inputData?.fixedRate ? inputData?.fixedRate : null}
                    onChange={(e) => handleInputChange('fixedRate', e.target.value)}
                    onFocus={() => onRestErrorKey('fixedRate')}
                    error={Boolean(error?.fixedRate)}
                    helperText={error?.fixedRate}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                    fullWidth
                />
            </Grid>
            {/* Row 2 */}
            <Grid size={gridSize}>
                <TextField
                    fullWidth
                    label="Margin (%)"   
                    value={inputData?.margin ? inputData?.margin : null}
                    onChange={(e) => handleInputChange('margin', e.target.value)}
                    variant="outlined"
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    onFocus={() => onRestErrorKey('margin')}
                    error={Boolean(error?.margin)}
                    helperText={error?.margin}
                    size="small"
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid>
            <Grid size={gridSize}>
                <TextField
                    fullWidth
                    label="Advance Amount ($)" 
                    value={inputData?.advanceAmount ? inputData?.advanceAmount : null}
                    onChange={(e) => handleInputChange('advanceAmount', e.target.value)}
                    variant="outlined"
                    size="small"
                    onFocus={() => onRestErrorKey('advanceAmount')}
                    error={Boolean(error?.advanceAmount)}
                    helperText={error?.advanceAmount}
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid>
            <Grid size={gridSize}>
                <TextField
                    fullWidth
                    label="Loan Term (Months)"                 
                    value={inputData?.loanTerm ? inputData?.loanTerm : null}
                    onChange={(e) => handleInputChange('loanTerm', e.target.value)}
                    variant="outlined"
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    onFocus={() => onRestErrorKey('loanTerm')}
                    error={Boolean(error?.loanTerm)}
                    helperText={error?.loanTerm}
                    size="small"
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid>

            {loanType === 'balloon' ? <Grid size={gridSize}>
                <TextField
                    fullWidth
                    label="Balloon Amount ($)"                    
                    value={inputData?.balloonAmount ? inputData?.balloonAmount : null}
                    onChange={(e) => handleInputChange('balloonAmount', e.target.value)}
                    variant="outlined"
                    size="small"
                    onFocus={() => onRestErrorKey('balloonAmount')}
                    error={Boolean(error?.balloonAmount)}
                    helperText={error?.balloonAmount}
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid> : null }
            {loanType === 'balloon' ? <Grid size={gridSize}>
                <TextField
                    fullWidth
                    label="Balloon Percentage (%)"                   
                    value={inputData.balloonPercentage ? inputData.balloonPercentage : null}
                    onChange={(e) => handleInputChange('balloonPercentage', e.target.value)}
                    variant="outlined"
                    size="small"
                    onFocus={() => onRestErrorKey('balloonPercentage')}
                    error={Boolean(error?.balloonPercentage)}
                    helperText={error?.balloonPercentage}
                    required={type === 'edit'}
                    disabled={type === 'view'}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                />
            </Grid> : null }
            {loanType === 'balloon' ?  <Grid size={gridSize}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        label="End Date"
                        value={inputData.balloonPaymentDate ? moment(inputData.balloonPaymentDate) : null}
                        onChange={(e) => handleInputChange('balloonPaymentDate', e.target.value)}
                        disabled={type === 'view'}
                        required={type === 'edit'}
                        slotProps={{
                            textField: {
                                required: "true",
                                InputLabelProps: { shrink: true },
                                size: "small",
                                margin: "normal",
                            },
                            field: {
                                clearable: true,
                            }
                        }}
                        sx={{ width: "100%" }}
                        format={fieldDateFormat}
                    />
                </LocalizationProvider>
            </Grid> : null }
        </>
    )
}

export default LoanInputParameters